<template>
	<div>
		<v-icon class="mr-1">
			<info-pink></info-pink>
		</v-icon>
		<span class="disclaimer">
			<slot></slot>
		</span>
	</div>
</template>



<script>

import InfoPink from '@/icons/InfoPink.vue';
export default {
    name: "DisclaimerComponent",
	components: {
		InfoPink
	}
}
</script>